export const HERO_CONFIG = {
  autoplayDuration: 5000,
  headerScrollThreshold: 80,
  logo: {
    src: "/qualitycollectionlogo.png", // your current/default logo (for transparent header)
    alt: "The Quality Collection Private Limited",
  },
  logoScrolled: {
    src: "/quality-collection-logo.webp", // the white version for the scrolled/glass pill state
    alt: "The Quality Collection Private Limited",
  },
} as const;